import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';

import useHttpStatus from '~/commons/hooks/useHttpStatus';
import Header from '../../layout/Header.jsx';
import PageHttp from '~/commons/components/PageHttp.jsx';
import FormItem from '../../forms/FormItem.jsx';

const PageItem = () => {
  const { _id } = useParams();
  const [res, req] = useHttpStatus();

  useEffect(() => {
    if (_id !== 'new') {
      req({ url: `/api/site/items/${_id}` });
    }
  }, [_id]);

  const breadcrumb =
    _id === 'self'
      ? []
      : [{ to: '../', children: 'Items' }];

  return _id === 'new' ? (
    <>
      <Header breadcrumb={breadcrumb}>New Item</Header>
      <FormItem />
    </>
  ) : (
    <PageHttp res={res}>
      {(doc) => (
        <>
          <Header breadcrumb={breadcrumb}>Edit</Header>
          <FormItem item={doc} />
        </>
      )}
    </PageHttp>
  );
};

export default PageItem;
